import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedUiAlertModule} from "@snelstart/ui-alert";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-algemene-vragen',
  standalone: true,
    imports: [CommonModule, SharedUiAlertModule],
  templateUrl: './tekst-algemene-vragen.component.html',
  styleUrl: './tekst-algemene-vragen.component.scss',
})
export class TekstAlgemeneVragenComponent {}
